/* Catalog filters and Productos navigation share server-rendered categories. */
(() => {
  const categoryLabels = {
    skincare: 'Skincare',
    maquillaje: 'Maquillaje',
    'cuerpo-cabello': 'Cuerpo y cabello',
    fragancias: 'Fragancias'
  };
  const normalizeOrder = (value) => {
    if (value === '10') return '10';
    return ['caja', 'case', '1-caja'].includes(value) ? 'caja' : 'all';
  };
  const getCards = (grid) => Array.from(grid.children).filter((card) => card.matches('.bb-product-card'));
  const readPage = async (url) => {
    const target = new URL(url, window.location.href);
    if (target.origin !== window.location.origin) throw new Error('Invalid catalog URL');
    // Keep paginated cards in the theme currently being previewed.
    const current = new URL(window.location.href);
    ['preview_theme_id', 'preview_key'].forEach((name) => {
      if (current.searchParams.has(name) && !target.searchParams.has(name)) {
        target.searchParams.set(name, current.searchParams.get(name));
      }
    });
    const response = await fetch(target.href, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Catalog unavailable');
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  };

  const initializeCatalogFilters = (root = document) => {
    root.querySelectorAll('[data-bb-catalog-filters]').forEach((filter) => {
      if (filter.dataset.bbCatalogReady) return;
      const container = filter.closest('.bb-container');
      const grid = container?.querySelector('[data-bb-catalog-product-grid]');
      if (!grid) return;
      filter.dataset.bbCatalogReady = 'true';

      const empty = container.querySelector('[data-bb-catalog-empty]');
      const status = filter.querySelector('[data-bb-filter-status]');
      const loading = filter.querySelector('[data-bb-catalog-loading]');
      const retry = filter.querySelector('[data-bb-catalog-retry]');
      const pagination = container.querySelector('[data-bb-catalog-pagination]');
      let cards = getCards(grid);
      let state = { order: 'all', category: 'all' };
      let busy = false;
      let nextPage = grid.dataset.bbNextPage || '';
      const currentUrl = new URL(window.location.href);
      if (Number(currentUrl.searchParams.get('page')) > 1) {
        currentUrl.searchParams.set('page', '1');
        nextPage = currentUrl.href;
      }

      const syncCategoryButtons = () => {
        const present = new Set(cards.map((card) => card.dataset.bbProductCategory));
        const options = filter.querySelector('[data-bb-category-options]');
        Object.entries(categoryLabels).forEach(([key, label]) => {
          let button = options.querySelector(`[data-bb-category="${key}"]`);
          if (!present.has(key)) {
            button?.remove();
            return;
          }
          if (!button) {
            button = document.createElement('button');
            button.type = 'button';
            button.className = 'bb-catalog-filters__option';
            button.dataset.bbCategory = key;
            button.setAttribute('aria-pressed', 'false');
            button.textContent = label;
          }
          options.appendChild(button);
        });
      };

      const readState = () => {
        const params = new URL(window.location.href).searchParams;
        const category = params.get('category');
        return {
          order: normalizeOrder(params.get('moq')),
          category: Object.hasOwn(categoryLabels, category) && cards.some((card) => card.dataset.bbProductCategory === category) ? category : 'all'
        };
      };

      const applyFilters = (updateUrl = false) => {
        let count = 0;
        cards.forEach((card) => {
          const matchesOrder = state.order === 'all'
            || (state.order === '10' && card.getAttribute('data-bb-min-10') === 'true')
            || (state.order === 'caja' && card.dataset.bbMinCase === 'true');
          const matchesCategory = state.category === 'all' || card.dataset.bbProductCategory === state.category;
          card.hidden = !(matchesOrder && matchesCategory);
          if (!card.hidden) count += 1;
        });
        filter.querySelectorAll('[data-bb-order]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.bbOrder === state.order));
        });
        filter.querySelectorAll('[data-bb-category]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.bbCategory === state.category));
        });
        if (empty) empty.hidden = count > 0 || busy;
        if (status) status.textContent = busy ? 'Cargando productos…' : `${count} ${count === 1 ? 'producto disponible' : 'productos disponibles'}.`;

        if (updateUrl) {
          const url = new URL(window.location.href);
          state.order === 'all' ? url.searchParams.delete('moq') : url.searchParams.set('moq', state.order);
          state.category === 'all' ? url.searchParams.delete('category') : url.searchParams.set('category', state.category);
          url.searchParams.delete('page');
          window.history.replaceState(window.history.state, '', url);
        }
      };

      const setBusy = (value) => {
        busy = value;
        grid.setAttribute('aria-busy', String(value));
        if (loading) loading.hidden = !value;
        filter.querySelectorAll('[data-bb-order], [data-bb-category]').forEach((button) => { button.disabled = value; });
      };

      const loadRemainingPages = async () => {
        if (busy) return;
        setBusy(Boolean(nextPage));
        if (retry) retry.hidden = true;
        const visited = new Set();
        try {
          while (nextPage) {
            const requested = new URL(nextPage, window.location.href).href;
            if (visited.has(requested)) throw new Error('Repeated catalog page');
            visited.add(requested);
            const doc = await readPage(requested);
            const sourceGrid = doc.querySelector('[data-bb-catalog-product-grid]');
            if (!sourceGrid) throw new Error('Catalog grid missing');
            const existing = new Set(cards.map((card) => card.dataset.bbProductId || card.getAttribute('href')));
            getCards(sourceGrid).forEach((card) => {
              const key = card.dataset.bbProductId || card.getAttribute('href');
              if (!existing.has(key)) {
                grid.appendChild(document.importNode(card, true));
                existing.add(key);
              }
            });
            cards = getCards(grid);
            nextPage = sourceGrid.dataset.bbNextPage || '';
          }
          // Stable grouping also keeps TOP products from later pages at the top.
          const priority = (card) => card.dataset.bbProductTop === 'true' ? (card.getAttribute('data-bb-min-10') === 'true' ? 0 : 1) : 2;
          cards.sort((a, b) => priority(a) - priority(b)).forEach((card) => grid.appendChild(card));
          if (pagination) pagination.hidden = true;
        } catch (error) {
          if (retry) retry.hidden = false;
        } finally {
          syncCategoryButtons();
          setBusy(false);
          state = readState();
          applyFilters();
        }
      };

      filter.addEventListener('click', (event) => {
        if (busy) return;
        const button = event.target.closest('[data-bb-order], [data-bb-category]');
        if (!button) return;
        if (button.dataset.bbOrder) state.order = normalizeOrder(button.dataset.bbOrder);
        if (button.dataset.bbCategory) state.category = button.dataset.bbCategory;
        applyFilters(true);
      });
      container.querySelector('[data-bb-catalog-reset]')?.addEventListener('click', () => {
        state = { order: 'all', category: 'all' };
        applyFilters(true);
      });
      retry?.addEventListener('click', loadRemainingPages);
      window.addEventListener('popstate', () => {
        if (!filter.isConnected) return;
        state = readState();
        applyFilters();
      });
      syncCategoryButtons();
      if (nextPage) loadRemainingPages();
      else {
        state = readState();
        applyFilters();
      }
    });
  };

  const completeNavigationCategories = async (header) => {
    if (!header || header.dataset.bbCategoryScanBusy || !header.dataset.bbMenuNextPage) return;
    header.dataset.bbCategoryScanBusy = 'true';
    const catalogUrl = new URL(header.dataset.bbCatalogUrl, window.location.href);
    const present = new Set(Array.from(header.querySelectorAll('[data-bb-nav-category]'), (link) => link.dataset.bbNavCategory));
    const visited = new Set();
    let next = header.dataset.bbMenuNextPage;
    try {
      while (next) {
        const url = new URL(catalogUrl);
        url.search = new URL(next, window.location.href).search;
        if (visited.has(url.href)) throw new Error('Repeated navigation page');
        visited.add(url.href);
        const doc = await readPage(url.href);
        const sourceGrid = doc.querySelector('[data-bb-catalog-product-grid]');
        if (!sourceGrid) throw new Error('Catalog grid missing');
        getCards(sourceGrid).forEach((card) => present.add(card.dataset.bbProductCategory));
        next = sourceGrid.dataset.bbNextPage || '';
      }
      header.querySelectorAll('.bb-products-menu__panel').forEach((panel) => {
        let group = panel.querySelector('[data-bb-nav-categories]');
        if (!group && Object.keys(categoryLabels).some((key) => present.has(key))) {
          group = document.createElement('div');
          group.className = 'bb-products-menu__group';
          group.dataset.bbNavCategories = '';
          const heading = document.createElement('p');
          heading.className = 'bb-products-menu__heading';
          heading.textContent = 'Categoría';
          group.appendChild(heading);
          panel.appendChild(group);
        }
        if (!group) return;
        Object.entries(categoryLabels).forEach(([key, label]) => {
          if (!present.has(key)) return;
          let link = group.querySelector(`[data-bb-nav-category="${key}"]`);
          if (!link) {
            link = document.createElement('a');
            link.dataset.bbNavCategory = key;
            link.href = `${catalogUrl.pathname}?category=${key}#bb-product-catalog`;
            link.textContent = label;
          }
          group.appendChild(link);
        });
      });
      header.dataset.bbMenuNextPage = '';
    } catch (error) {
      // Existing links remain usable; retry on the next opening.
    } finally {
      delete header.dataset.bbCategoryScanBusy;
    }
  };

  const initializeProductsMenus = (root = document) => {
    root.querySelectorAll('[data-bb-products-menu]').forEach((menu) => {
      if (menu.dataset.bbMenuReady) return;
      menu.dataset.bbMenuReady = 'true';
      const summary = menu.querySelector('summary');
      const panel = menu.querySelector('.bb-products-menu__panel');
      const mobile = menu.closest('.bb-header__mobile');
      let closeTimer;
      const setOpen = (open, returnFocus = false) => {
        window.clearTimeout(closeTimer);
        if (open) {
          menu.closest('header')?.querySelectorAll('[data-bb-products-menu][open]').forEach((other) => {
            if (other !== menu) {
              other.open = false;
              other.querySelector('summary')?.setAttribute('aria-expanded', 'false');
            }
          });
          completeNavigationCategories(menu.closest('header'));
        }
        menu.open = open;
        summary.setAttribute('aria-expanded', String(open));
        if (returnFocus) summary.focus({ preventScroll: true });
      };
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        setOpen(!menu.open);
      });
      menu.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(menu.open)));
      menu.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && !mobile) setOpen(true);
      });
      menu.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse' || mobile || panel.contains(document.activeElement)) return;
        closeTimer = window.setTimeout(() => setOpen(false), 180);
      });
      menu.addEventListener('focusout', (event) => {
        if (!mobile && !menu.contains(event.relatedTarget)) setOpen(false);
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open && !mobile) {
          event.preventDefault();
          event.stopPropagation();
          setOpen(false, true);
        } else if (event.key === 'ArrowDown' && event.target === summary) {
          event.preventDefault();
          setOpen(true);
          panel.querySelector('a')?.focus();
        }
      });
      panel.addEventListener('click', (event) => {
        if (mobile || !event.target.closest('a')) return;
        setOpen(false);
      });
      document.addEventListener('pointerdown', (event) => {
        if (!mobile && menu.isConnected && menu.open && !menu.contains(event.target)) setOpen(false);
      });
      // Mobile keeps its disclosure state when focus moves, the background is
      // touched, or the main navigation closes. Only its summary toggles it.
    });
  };

  initializeCatalogFilters();
  initializeProductsMenus();
  document.addEventListener('shopify:section:load', (event) => {
    initializeCatalogFilters(event.target);
    initializeProductsMenus(event.target);
  });
})();
